<template>
    <div>
        <swiper-container ref="slider" :slides-per-view="6" :space-between="12" :style="CalcSliderHeight">
            <swiper-slide v-for="(item, index) in slides" @click="openImageSlider(index)">
                <div class="bg-white rounded aspect-square p-1">
                    <NuxtImg
                        preset="thumbnail"
                        background="transparent"
                        placeholder
                        :alt="altName"
                        class="w-full h-full object-contain rounded-md"
                        :src="item.original_url"
                    />
                </div>
            </swiper-slide>
        </swiper-container>
        <UModal :ui="{ width: 'w-full sm:max-w-7xl' }" v-model="openSliderModal">
            <LazyPagesProductImageSlider :alt="altName" :image-collection="slides" :click-slide="clickedSwiperSlide" />
        </UModal>
    </div>
</template>

<script lang="ts" setup>
import type { IMedia } from "~/libs/types/api/media";

const props = defineProps({
    slides: {
        type: Array as PropType<IMedia[]>,
        required: true,
    },
    altName: String,
});

const openSliderModal = ref(false);
const clickedSwiperSlide = ref(0);

const slider: Ref<HTMLDivElement | null> = ref(null);

const { height: sliderHeight, width: sliderWidth } = useElementBounding(slider);

const CalcSliderHeight = computed(() => {
    return {
        height: sliderWidth.value / 6 - 12 + "px",
    };
});

function openImageSlider(index: number) {
    openSliderModal.value = true;
    clickedSwiperSlide.value = index;
}
</script>

<style></style>
